import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export function DraggableItem({
  item,
  index,
  children,
  isDragDisabled = false,
}) {
  return (
    <Draggable
      draggableId={item.id.toString()}
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => children(provided, snapshot)}
    </Draggable>
  );
}

export default function DragNDrop({
  onDragComplete,
  onDragStart,
  data,
  children,
  dropableId = "list",
  ...rest
}) {
  function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const quotes = reorder(data, result.source.index, result.destination.index);

    onDragComplete(quotes);
  }

  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Droppable droppableId={dropableId} {...rest}>
        {(provided) => children(provided)}
      </Droppable>
    </DragDropContext>
  );
}
